import React from 'react';

const BidOfferTable = React.forwardRef(({bids, offers}, ref) => {
    return (
        <div className="bid-offer-table" ref={ref}>
            <table>
                <thead>
                <tr>
                    {/*<th style={{ width: "20%",textAlign: "left" }}>Bid</th>
                    <th style={{ width: "18%", textAlign: "left" }}>Orders</th>
                    <th style={{ textAlign: "right", width: "20%",paddingRight:"10px" }}>Qty.</th>
                    <th style={{  width: "30%" }}>Offer</th>
                    <th style={{ width: "18%" }}>Orders</th>
                    <th style={{ textAlign: "right", width: "20%" }}>Qty.</th>*/}
                    <th style={{textAlign: "left"}}>Bid</th>
                    <th style={{textAlign: "left"}}>Orders</th>
                    <th style={{textAlign: "right", paddingRight: "10px"}}>Qty.</th>
                    <th></th>
                    <th style={{textAlign: "left"}}>Offer</th>
                    <th style={{textAlign: "left"}}>Orders</th>
                    <th style={{textAlign: "right"}}>Qty.</th>
                </tr>
                </thead>
                <tbody>
                {bids.map((bid, index) => (
                    <tr key={index}>
                        <td style={{textAlign: "left", color: "#6666FF"}}>{bid.price.toFixed(2)}</td>
                        <td style={{color: "#6666FF", textAlign: "left"}}>{bid.orders}</td>
                        <td style={{textAlign: "right", color: "#6666FF", paddingRight: "10px"}}>{bid.quantity}</td>
                        <td></td>
                        <td style={{
                            color: "#FF6666",
                            textAlign: "left"
                        }}>{offers[index]?.price.toFixed(2) || '0.00'}</td>
                        <td style={{color: "#FF6666", textAlign: "left"}}>{offers[index]?.orders || 0}</td>
                        <td style={{textAlign: "right", color: "#FF6666"}}>{offers[index]?.quantity || 0}</td>
                    </tr>
                ))}
                {/* Totals */}
                <tr className="total-row">
                    <td style={{color: "#6666FF", textAlign: "left"}}>Total</td>
                    <td></td>
                    <td style={{textAlign: "right", color: "#6666FF", paddingRight: "10px"}}>
                        {bids.reduce((acc, bid) => acc + bid.quantity, 0)}
                    </td>
                    <td></td>
                    <td style={{color: "#FF6666", textAlign: "left"}}>Total</td>
                    <td></td>
                    <td style={{textAlign: "right", color: "#FF6666"}}>
                        {offers.reduce((acc, offer) => acc + offer.quantity, 0)}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
});
export default BidOfferTable;
